import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descarga la guía en PDF con 60 páginas prácticas'
  }, {
    num: '2',
    text: 'Aplica los prompts en las áreas clave: productividad, negocio, vida personal'
  }, {
    num: '3',
    text: 'Personaliza cada solución con ejemplos y casos reales'
  }];
  return <section className="py-14 md:py-24 px-4 md:px-6 bg-[#0A0A0A] relative border-t border-[#D4AF37]/10" data-id="element-302">
      <div className="max-w-5xl mx-auto" data-id="element-303">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-304">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#E8E0D0] mb-4" data-id="element-305">
            Cómo funciona
          </h2>
          <div className="w-16 md:w-24 h-1 bg-[#D4AF37] mx-auto rounded-full" data-id="element-306"></div>
        </motion.div>

        {/* Desktop: horizontal grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-8 relative" data-id="element-307">
          {/* Connecting Line (Desktop only) */}
          <div className="absolute top-12 left-[16%] right-[16%] h-[2px] bg-gradient-to-r from-[#D4AF37]/10 via-[#D4AF37]/40 to-[#D4AF37]/10 z-0" data-id="element-308"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-309">
              <div className="w-24 h-24 rounded-full bg-[#111111] border-2 border-[#D4AF37] shadow-[0_0_20px_rgba(212,175,55,0.15)] flex items-center justify-center mb-6" data-id="element-310">
                <span className="text-4xl font-serif font-bold text-[#D4AF37] drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]" data-id="element-311">
                  {step.num}
                </span>
              </div>
              <p className="text-lg text-[#E8E0D0] font-medium px-4" data-id="element-312">
                {step.text}
              </p>
            </motion.div>)}
        </div>

        {/* Mobile: vertical timeline */}
        <div className="md:hidden relative" data-id="element-313">
          {/* Vertical connecting line */}
          <div className="absolute left-[27px] top-6 bottom-6 w-[2px] bg-gradient-to-b from-[#D4AF37]/10 via-[#D4AF37]/30 to-[#D4AF37]/10 z-0" data-id="element-314"></div>

          <div className="flex flex-col gap-6" data-id="element-315">
            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="relative z-10 flex items-center gap-4" data-id="element-316">
                <div className="w-14 h-14 rounded-full bg-[#111111] border-2 border-[#D4AF37] shadow-[0_0_15px_rgba(212,175,55,0.15)] flex items-center justify-center shrink-0" data-id="element-317">
                  <span className="text-2xl font-serif font-bold text-[#D4AF37] drop-shadow-[0_0_8px_rgba(212,175,55,0.4)]" data-id="element-318">
                    {step.num}
                  </span>
                </div>
                <p className="text-base text-[#E8E0D0] font-medium" data-id="element-319">
                  {step.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}